export const PROPOSAL_REJECT_REASON_CODES = [
  'too_expensive',
  'other_quote',
  'other_provider',
  'postponed',
  'not_a_fit',
  'lead_time',
  'other',
];

export function isValidRejectReasonCode(code) {
  return PROPOSAL_REJECT_REASON_CODES.includes(code);
}

export function mapRejectReasonOptions(translate) {
  return PROPOSAL_REJECT_REASON_CODES.map((value) => ({
    value,
    label: translate(value),
  }));
}

export function formatRejectReason({ code, note, label }) {
  const trimmed = typeof note === 'string' ? note.trim() : '';
  if (code === 'other') {
    return trimmed || label || '';
  }
  if (code && label) {
    return trimmed ? `${label}: ${trimmed}` : label;
  }
  return trimmed;
}
